/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const PresentationSignRequestDidMethod: core.serialization.Schema<
    serializers.PresentationSignRequestDidMethod.Raw,
    Truvity.PresentationSignRequestDidMethod
> = core.serialization.enum_(['key', 'web']);

export declare namespace PresentationSignRequestDidMethod {
    export type Raw = 'key' | 'web';
}
